import { Flex, HStack, Icon, Input, Text } from "@chakra-ui/react";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import 'common/assets/css/fileUpload.css';


const FileUpload = ({
    label,
    name,
    icon: IconComponent,
    iconColor,
    selectedFile,
    title,
    handleFileChange,
    inputId,
    onChange,
    onBlur,
    onInputCapture,
    errorText,
    type = "file",
    borderColor,
    accept,
    ...props
}) => {
    const colors = globalStyles.colors;

    return (
        <>
            {label && <Text className="labels">{label}</Text>}
            <Flex className="attachMentInput" alignItems="center" gap="13px">
                <HStack
                    as="label"
                    htmlFor={inputId}
                    className="attachMentInput-label"
                    border="1px solid"
                    borderColor={borderColor || colors.borderColor}
                    cursor="pointer"
                >
                    {IconComponent && <Icon as={IconComponent} color={iconColor || colors.cta['100']} />}
                    <Text>{title}</Text>
                    <Input
                        name={name}
                            id={inputId}
                            type={type}
                            accept={accept}
                            display="none"
                            onChange={handleFileChange || onChange}
                            onBlur={onBlur}
                            onInputCapture={onInputCapture}
                            {...props}
                    />
                </HStack>
                <Text className="fileName" fontSize="sm" mt={1} color={errorText ? colors.errorText : "inherit"}>
                    {selectedFile || constant.noFileChoosen}
                </Text>
            </Flex>
            {errorText && <Text className="errorText">{errorText}</Text>}
        </>

    );
};

export default FileUpload;
